import { ServiceLayout } from "../components/ServiceLayout";
import { Seo } from "../components/Seo";
import { PHOTOS } from "../data/site";

export default function LawnCare() {
    return (
        <div data-testid="lawn-care-page">
            <Seo title="Lawn Mowing & Lawn Care in Adelaide | Lawn Busters"
                description="Mowing, edging, hedge trimming, weed removal and garden clean-ups across Adelaide. 5.0-star rated local team. Book online or get a free quote today." />
            <ServiceLayout
                eyebrow="Lawn Care — Adelaide"
                titleLines={["Lawn Care", "Done Right"]}
                intro="From a quick mow to a full garden cleanup, we keep Adelaide lawns neat, healthy and looking their best — for homes, rentals and managed properties."
                image={PHOTOS.lawn}
                imageAlt="Lawn care and mowing in Adelaide"
                preselect="Lawn Care"
                stockImage={false}
                items={[
                    { name: "Lawn mowing", desc: "Even, tidy cuts on a one-off or regular basis, with clippings taken care of." },
                    { name: "Hedge trimming", desc: "Hedges and shrubs shaped and trimmed back into line." },
                    { name: "Edge lining", desc: "Crisp, clean edges along paths, driveways and garden beds." },
                    { name: "Weed removal", desc: "Weeds cleared from lawns, garden beds and paving." },
                    { name: "Garden care", desc: "General garden tidy-ups to keep beds and plants looking their best." },
                    { name: "General lawn maintenance", desc: "Ongoing care schedules so your lawn never gets away from you." },
                    { name: "Garden cleanups", desc: "Full cleanups for overgrown or neglected gardens and yards." },
                ]}
                note="One-off job or ongoing maintenance — both are welcome. Book a single visit to get things back in shape, or set up regular lawn and property maintenance so you never have to think about it."
                secondImage={PHOTOS.teamGroup}
                secondImageAlt="The Lawn Busters team"
                stockSecond={false}
            />
        </div>
    );
}
